import React, { useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';

import PropTypes from 'prop-types';
const EditPreconciliacion = ({
  currentPreconciliacion,
  savePreconciliacion,
  closeModal
}) => {
  const [preconciliacion, setPreconciliacion] = useState(
    currentPreconciliacion
  );
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Row>
          <Col>
            <Form.Group className="mb-4">
              <Form.Label>Folio Externo</Form.Label>
              <FormControl
                onChange={e => setPreconciliacion(e.target.value)}
                type="text"
                defaultValue={preconciliacion}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              type="button"
              color="primary"
              size="sm"
              onClick={() => {
                savePreconciliacion(preconciliacion);
                closeModal();
              }}
            >
              Guardar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
EditPreconciliacion.propTypes = {
  idQueja: PropTypes.string.isRequired,
  closeModal: PropTypes.func,
  currentPreconciliacion: PropTypes.string,
  savePreconciliacion: PropTypes.func
};
export default EditPreconciliacion;
